<template>
  <div v-if="about">
    <h3 class="mb-5">Video Rotate</h3>
    <div class="h4 mb-5">最多3個. 為版面呈現正常, 建議上傳Preview Image</div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in about.video_rotates" :key="i">
      <template v-slot:head>
        <h3>Video {{ i + 1 }}</h3>
      </template>
      <template v-slot:body>
        <!-- Title -->
        <label class="form-item d-flex py-5">
          <h4 class="w-180px">Title</h4>
          <div class="flex-grow-1 flex-basis-0">
            {{ item.title }}
          </div>
        </label>
        <!-- UploadType -->
        <div class="form-item d-flex py-5">
          <h4 class="w-100px mr-80px">Upload Type</h4>
          <div class="h4">
            {{
            item.upload_type === 'file'
            ? '自電腦上傳影片'
            : '來自影片連結'
            }}
          </div>
        </div>
        <!-- UploadType: computer -->
        <div v-if="item.upload_type === 'file'">
          <!-- FileLink -->
          <div class="form-item d-flex py-5">
            <h4 class="w-100px mr-80px">檔案連結</h4>
            <div class="h4">
              <a
                :href="item.url"
                class="text-decoration-none"
                style="color: #194cc3"
              >{{ item.url }}</a
              >
            </div>
          </div>
        </div>
        <!-- UploadType: link -->
        <div v-if="item.upload_type === 'link'">
          <!-- Youtube  -->
          <div class="form-item d-flex py-5">
            <h4 class="w-100px mr-80px">影片連結</h4>
            <div class="h4">
              <a
                :href="item.url"
                class="text-decoration-none"
                style="color: #194cc3"
              >{{ item.url }}</a
              >
            </div>
          </div>
          <!-- Youku  -->
          <!--<div class="form-item d-flex py-5">-->
          <!--<h4 class="w-100px mr-80px">Youku</h4>-->
          <!--<div class="h4">-->
          <!--<a-->
          <!--:href="item.youkuUrl"-->
          <!--class="text-decoration-none"-->
          <!--style="color: #194cc3"-->
          <!--&gt;{{ item.youkuUrl }}</a-->
          <!--&gt;-->
          <!--</div>-->
          <!--</div>-->
        </div>
        <!-- Preview Image -->
        <div class="d-flex px-5 py-5">
          <div class="h4">Preview Image</div>
          <div
            class="w-305px h-187px ml-auto bg-cover bg-center"
            :style="{
              'background-image': `url(${item.preview_image})`,
              'border-radius': '6.2px',
              'background-size': 'contain',
            }"
          ></div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PageCollapse,
  },
};
</script>

<style></style>
